var exports = {
  "lD": "ThreadSidePanel.module__split___OWhCUm",
  "QA": "ThreadSidePanel.module__splitMain___OWhCUm",
  "nd": "ThreadSidePanel.module__panel___OWhCUm",
  "Di": "ThreadSidePanel.module__resizeHandle___OWhCUm",
  "wx": "ThreadSidePanel.module__header___OWhCUm",
  "nr": "ThreadSidePanel.module__headerIcon___OWhCUm",
  "qd": "ThreadSidePanel.module__headerTitle___OWhCUm",
  "$s": "ThreadSidePanel.module__headerActions___OWhCUm",
  "Qs": "ThreadSidePanel.module__content___OWhCUm",
  "rp": "ThreadSidePanel.module__membersPopout___OWhCUm",
  "xm": "ThreadSidePanel.module__membersPopoutList___OWhCUm",
};

module.exports = exports;
